import type { BoxProps } from '@mui/material/Box';
import type { Breakpoint } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { CONFIG } from 'src/global-config';

// ----------------------------------------------------------------------

export type AuthSplitSectionProps = BoxProps & {
  title?: string;
  method?: string;
  imgUrl?: string;
  subtitle?: string;
  layoutQuery?: Breakpoint;
  methods?: {
    path: string;
    icon: string;
    label: string;
  }[];
};

export function AuthSplitSection({
  sx,
  method,
  methods,
  layoutQuery = 'md',
  title = 'Work with Xpanse',
  imgUrl = `${CONFIG.assetsDir}/assets/illustrations/big-x.svg`,
  subtitle = ' connect faster, collaborate smarter, and streamline operations',
  ...other
}: AuthSplitSectionProps) {
  return (
    <Box
      sx={[
        (theme) => ({
          width: '1',

          display: 'none',
          maxWidth: '50%',
          position: 'relative',
          pt: 'var(--layout-header-desktop-height)',
          [theme.breakpoints.up(layoutQuery)]: {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <div>
        <Typography variant="h3" sx={{ textAlign: 'center', color: 'white' }}>
          {title}
        </Typography>

        {subtitle && (
          <Typography sx={{ color: 'white', textAlign: 'center', mt: 2 }}>{subtitle}</Typography>
        )}

        <Box
          component="img"
          alt="Dashboard illustration"
          src={imgUrl}
          sx={{ width: 1, aspectRatio: '10/9', objectFit: 'cover', mt: -10 }}
        />
      </div>
    </Box>
  );
}
